import React from 'react';
import {get} from 'axios';
import ReactHtmlParser from 'react-html-parser';

class CookiePolicy extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			policy: {}
		};
	}
	componentDidMount() {
		get(`https://www.iubenda.com/api/privacy-policy/42385445/cookie-policy`)
		.then(({ data: policy }) => {
			this.setState({policy});
		});
		
	}	

	render(){
		const cookiePolicy = this.state.policy.content;
		// console.log(cookiePolicy);
		return(
			<div className="privacyPolicy iubenda-white no-brand iubenda-embed iub-no-markup iub-body-embed">
				{ ReactHtmlParser(cookiePolicy) }
			</div>
		);
	}
}

export default CookiePolicy;



// WEBPACK FOOTER //
// ./src/components/Policies/CookiePolicy.js